import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
        await logout();
        navigate('/');
    };

    const showHeader = location.pathname === '/main' || location.pathname === '/teacher';

    return (
        <div className="container">
            {showHeader && (
                <div className="header">
                    {user && <span>안녕하세요, {user.first_name || user.username}님!</span>}
                    <a href="#!" onClick={handleLogout}>로그아웃</a>
                </div>
            )}
            <main>{children}</main>
        </div>
    );
};

export default Layout;
